import { render, staticRenderFns } from "./security.vue?vue&type=template&id=3a232bb9&scoped=true&lang=pug&"
import script from "./security.vue?vue&type=script&lang=js&"
export * from "./security.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a232bb9",
  null
  
)

export default component.exports